var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 0.333344C3.76675 0.333344 3.50008 0.60001 3.50008 1.00001V13C3.50008 13.4 3.76675 13.6667 4.16675 13.6667C4.56675 13.6667 4.83341 13.4 4.83341 13V1.00001C4.83341 0.60001 4.56675 0.333344 4.16675 0.333344ZM0.833415 7.00001C0.433415 7.00001 0.166748 7.26668 0.166748 7.66668V13C0.166748 13.4 0.433415 13.6667 0.833415 13.6667C1.23341 13.6667 1.50008 13.4 1.50008 13V7.66668C1.50008 7.26668 1.23341 7.00001 0.833415 7.00001ZM7.50008 4.33334C7.10008 4.33334 6.83341 4.60001 6.83341 5.00001V13C6.83341 13.4 7.10008 13.6667 7.50008 13.6667C7.90008 13.6667 8.16675 13.4 8.16675 13V5.00001C8.16675 4.60001 7.90008 4.33334 7.50008 4.33334ZM10.8334 9.66668C10.4334 9.66668 10.1667 9.93334 10.1667 10.3333V13C10.1667 13.4 10.4334 13.6667 10.8334 13.6667C11.2334 13.6667 11.5001 13.4 11.5001 13V10.3333C11.5001 9.93334 11.2334 9.66668 10.8334 9.66668Z",
    fill: "#F9F9FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.12402cda5d63c517a89438ef9b52ea56.svg";
export { ForwardRef as ReactComponent };